class StickyMargin {
  constructor() {
    this.stickyFooter = document.querySelector('.sticky');
    this.events();
  }
  events() {
    if (this.stickyFooter) {
      const footer = document.getElementsByTagName('footer')[0];

      if (window.innerWidth > 472) {
        footer.style.marginBottom = "110px";
      } else {
        footer.style.marginBottom = "200px";
      }
    }
  }
}

export default StickyMargin;